module.exports = __webpack_public_path__ + "9788f41e/img/share-icon.0f8a11b4.svg";